import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  myCurrentTab: 1,
 
};

const serviceRequest = createSlice({
  name: "service",
  initialState,

  reducers: {
    
    setMyCurrentTabRedux: (state, action) => {
      const userD = action.payload;

      state.myCurrentTab = userD;
    },},
});

export const {setMyCurrentTabRedux
} = serviceRequest.actions;

export default serviceRequest.reducer;
